import React, { useEffect, useState } from 'react';
import { NavLink, Link, useLocation } from 'react-router-dom';
import Icon from './Icon';
import { brands } from '../data';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  const close = () => setOpen(false);

  return (
    <header className={`nav ${scrolled ? 'is-scrolled' : ''}`}>
      <div className="container nav__inner">
        <Link to="/" className="nav__logo" onClick={close}>
          <img
            src={`${process.env.PUBLIC_URL}/images/Logo-caladium.png`}
            alt="Caladium Systems"
          />
        </Link>

        <nav className={`nav__links ${open ? 'is-open' : ''}`}>
          <NavLink to="/" end className={({ isActive }) => (isActive ? 'is-active' : '')}>
            Home
          </NavLink>
          <NavLink to="/about" className={({ isActive }) => (isActive ? 'is-active' : '')}>
            About
          </NavLink>
          <div className="nav__dropdown">
            <NavLink to="/brands" className={({ isActive }) => (isActive ? 'is-active' : '')}>
              Brands <Icon name="chevron-down" size={15} />
            </NavLink>
            <div className="nav__menu">
              {brands.map((b) =>
                b.website ? (
                  <a
                    key={b.id}
                    href={b.website}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={close}
                  >
                    {b.name}
                  </a>
                ) : (
                  <Link key={b.id} to="/brands" onClick={close}>
                    {b.name}
                  </Link>
                )
              )}
            </div>
          </div>
          <NavLink to="/journey" className={({ isActive }) => (isActive ? 'is-active' : '')}>
            Journey
          </NavLink>
          <NavLink to="/founder" className={({ isActive }) => (isActive ? 'is-active' : '')}>
            Founder
          </NavLink>
          <NavLink to="/philosophy" className={({ isActive }) => (isActive ? 'is-active' : '')}>
            Innovation
          </NavLink>
          <Link to="/#impact" onClick={close}>Impact</Link>
          <NavLink to="/careers" className={({ isActive }) => (isActive ? 'is-active' : '')}>
            Careers
          </NavLink>
          <NavLink to="/contact" className={({ isActive }) => (isActive ? 'is-active' : '')}>
            Contact
          </NavLink>
        </nav>

        <Link to="/about" className="btn btn--outline nav__cta">
          Explore Ecosystem <Icon name="arrow-right" size={16} />
        </Link>

        <button
          type="button"
          className={`nav__burger ${open ? 'is-open' : ''}`}
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          <span />
          <span />
          <span />
        </button>
      </div>
    </header>
  );
}
